module.exports = __webpack_public_path__ + "img/new_49.d0215567.jpg";